/**
 * W66.W6 — Left rail listing 10 Top-10 accounts.
 * Seeded accounts show name + posture pill.
 * Unseeded accounts render as gray "Coming in W66.W7" placeholder rows.
 */

import React from "react";
import PosturePill from "./PosturePill";

export interface TopTenAccount {
  rank: number;
  name: string;
  seeded: boolean;
  id: number | null;
  plan_id: string | null;
  posture: string | null;
  composite_score: number | null;
  status: string | null;
}

interface TopTenLeftRailProps {
  accounts: TopTenAccount[];
  selectedId: number | null;
  onSelect: (id: number | null, name: string) => void;
}

export default function TopTenLeftRail({
  accounts,
  selectedId,
  onSelect,
}: TopTenLeftRailProps) {
  return (
    <nav
      style={{
        width: 240,
        minWidth: 200,
        maxWidth: 260,
        borderRight: "1px solid #E5E7EB",
        background: "#F9FAFB",
        height: "100%",
        overflowY: "auto",
        flexShrink: 0,
      }}
      aria-label="Top-10 accounts"
    >
      <div
        style={{
          padding: "16px 16px 8px",
          fontSize: 11,
          fontWeight: 700,
          color: "#6B7280",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        Top-10 Accounts
      </div>

      {accounts.map((acct) => {
        const isSelected = acct.seeded && acct.id === selectedId;

        return (
          <button
            key={acct.rank}
            onClick={() => {
              if (acct.seeded && acct.id) {
                onSelect(acct.id, acct.name);
              }
            }}
            disabled={!acct.seeded}
            style={{
              display: "block",
              width: "100%",
              padding: "12px 16px",
              textAlign: "left",
              background: isSelected ? "#FFFFFF" : "transparent",
              borderLeft: isSelected
                ? "3px solid #111827"
                : "3px solid transparent",
              borderTop: "none",
              borderRight: "none",
              borderBottom: "1px solid #E5E7EB",
              cursor: acct.seeded ? "pointer" : "default",
              opacity: acct.seeded ? 1 : 0.5,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginBottom: 2,
              }}
            >
              <span
                style={{
                  fontSize: 10,
                  color: "#9CA3AF",
                  fontWeight: 600,
                  minWidth: 18,
                }}
              >
                #{acct.rank}
              </span>
              <span
                style={{
                  fontSize: 13,
                  fontWeight: isSelected ? 700 : 500,
                  color: acct.seeded ? "#111827" : "#9CA3AF",
                  lineHeight: 1.2,
                }}
              >
                {acct.name}
              </span>
            </div>

            {acct.seeded ? (
              <div style={{ paddingLeft: 24 }}>
                <PosturePill posture={acct.posture} small />
              </div>
            ) : (
              <div
                style={{
                  paddingLeft: 24,
                  fontSize: 10,
                  color: "#9CA3AF",
                  fontStyle: "italic",
                }}
              >
                Coming in W66.W7
              </div>
            )}
          </button>
        );
      })}
    </nav>
  );
}
